import { CurrencyPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { getCurrencyInfo } from '../components/currency-input/currency-input.component';
import { RegisterData, RegisterParams } from '../resolvers/register.resolver';
import {
  getChildRoute,
  TypedActivatedRoute,
  TypedActivatedRouteSnapshot,
} from '../utils/route-utils';

export function getCurrentRegisterCurrency(
  routeSnapshot: TypedActivatedRouteSnapshot<{}, Partial<RegisterData>>,
) {
  const register = getChildRoute(routeSnapshot).data.register;
  return register?.currency || register?.defaultCurrency || '';
}

@Pipe({
  name: 'aacurrency',
  standalone: false,
})
export class AaCurrencyPipe extends CurrencyPipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) private locale: string,
    @Inject(ActivatedRoute) private route: TypedActivatedRoute<RegisterParams, RegisterData>,
  ) {
    super(locale);
  }

  transform(value: any, currencyCode?: string) {
    if (value == null) {
      return value;
    }

    currencyCode = currencyCode || getCurrentRegisterCurrency(this.route.snapshot);

    const currencyInfo = getCurrencyInfo(this.locale, currencyCode);

    let display = currencyInfo.symbol;

    if (/^([A-Z]{3})$/.test(display)) {
      // If it uses a currency code, put a space between currency and value
      display = ` ${display} `;
    }

    const digitsInfo = `1.${currencyInfo.nbOfDigits}-${currencyInfo.nbOfDigits}`;

    const result = super.transform(
      Math.abs(value),
      currencyCode,
      display || 'symbol-narrow',
      digitsInfo,
    );

    if (value < 0) {
      return `(${result})`;
    }

    return result;
  }
}
